import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { selectOptionsToDomain } from 'src/adapters/mapper/cashmemberRegister/cashmemberRegister.mapper'
import { PartnerRegisterRequest } from 'src/models/interface/partnerRegister'
import { SelectOptionsResponse, SelectUriEnum } from 'src/models/interface/selectOptions'

interface RetryConfig extends AxiosRequestConfig {
  retry: number
  retryDelay: number
}

const axiosConfig: RetryConfig = {
  timeout: 3000,
  retry: 3,
  retryDelay: 1000
}

export class partnerRegisterClient {
  private httpInstance: AxiosInstance

  constructor(httpInstance: AxiosInstance) {
    this.httpInstance = httpInstance
  }

  private async getSelectOptions(field: string) {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/parceiro/registro/opcoes-inputs/${SelectUriEnum[field]}/`
    const { data } = await this.httpInstance.get<SelectOptionsResponse>(url, axiosConfig)
    return selectOptionsToDomain(data, field)
  }

  getAllSelectOptions() {
    const selectOptions = [
      'ramo_atuacao',
      'regional',
      'produtos_cashme',
      'porte_empresa',
      'motivo_parceria',
      'como_encontrou',
      'trabalha_com_garantia_imovel'
    ]

    return Promise.all(selectOptions.map(option => this.getSelectOptions(option)))
  }

  async sendPartnerRegistration(register: PartnerRegisterRequest) {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/parceiro/registro/enviar/`
    return await (register.id ? this.httpInstance.put(url, register) : this.httpInstance.post(url, register))
  }

  async finishPartnerRegistration(id: string) {
    const url = `${process.env.NEXT_PUBLIC_API_BASE_URL}/parceiro/registro/concluir-cadastro/${id}/`

    return await this.httpInstance.put(url)
  }
}
